<template>
  <b-sidebar
    id="sidebar-canvas"
    :visible="showCanvasModal"
    title=""
    left
    bg-variant="transparent"
  >
    <div class="px-3 py-2" style="background-color: transparent">
      <b-img
        src="resources/images/canvas/arteriesandveins.gif"
        fluid
        style="width:80%;heiaght:80%"
      >
      </b-img>
    </div>
  </b-sidebar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {
    remoteUser: {
      type: Object,
      required: true
    },
    profile: {
      type: Object,
      required: true
    },
    roomId: {
      type: String,
      required: true
    }
  },
  beforeMount() {
    this.$store
      .dispatch("session/getCanvas", this.roomId)
      .then(data => {
        if (this.isFirstEntry) {
          this.canvasModalIsOpenState = data.isOpen;
        }
      })
      .catch(error => {});

    this.$store
      .dispatch("session/getConjure", this.roomId)
      .then(data => {
        if (this.isFirstEntry) {
          //Prepare anything on first entry
        }
      })
      .catch(error => {});
  },
  methods: {},
  computed: {
    ...mapGetters({
      canvas: "session/canvas"
    }),
    showCanvasModal() {
      return this.canvas ? this.canvas.isOpen : false;
    }
  },
  watch: {},
  data() {
    return {
      isFirstEntry: true,
      audios: {
        sendMsg: {
          audio: null,
          file: "resources/audios/sendmsg.mp3"
        },
        receivedMsg: {
          audio: null,
          file: "resources/audios/sendmsg.mp3"
        },
        newUnseenMsg: {
          audio: null,
          file: "resources/audios/sendmsg.mp3"
        }
      },
      canvasModalIsOpenState: false // to determine whether the chat window should be open or closed
    };
  }
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
<style scoped></style>
